module.exports = __webpack_public_path__ + "img/bgc25.fe5582c0.png";